module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', {
    staticClass: "fa fa-question"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" Help")], 1), _vm._v(" "), (_vm.isDesktop || _vm.isTablet) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', [_c('select-input', {
    attrs: {
      "list": _vm.lang,
      "placeholder": "Select Language...",
      "no-form": ""
    },
    on: {
      "change": _vm.getManual
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right"
    }
  }, [_c('p', [_vm._v("Problems with the system? "), _c('a', {
    attrs: {
      "href": "https://support.xolas.io",
      "target": "_blank"
    }
  }, [_vm._v("support.xolas.io")])])])], 1) : _vm._e(), _vm._v(" "), _c(_vm.comp, {
    tag: "component"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', [_c('b', [_vm._v("Version " + _vm._s(_vm.ver))]), _vm._v(" For " + _vm._s(_vm.clientName))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aecbd90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/Help.vue
// module id = 1393
// module chunks = 0